import React, { useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Input from 'components/atoms/input';

const Agency = ({ errors, isLoading, agencies }) => {
  const agencyOptions = useMemo(() =>
    agencies.map(({ guid, legalname }) => ({
      id: guid,
      label: legalname,
    })),
  );

  return (
    <div className="admin-patient-form-block">
      <span>Agency</span>
      <Row>
        <Col lg="12" md="12" sm="12" xs="12">
          <Input
            label="Agency"
            id="agencyGuid"
            type="select"
            disabled={isLoading}
            isMulti={false}
            options={agencyOptions}
          />
          {errors.agencyGuid ? (
            <div className="input-error">{errors.agencyGuid}</div>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

Agency.defaultProps = {
  isLoading: false,
};

Agency.propTypes = {
  errors: PropTypes.shape({
    AgencyType: PropTypes.string,
    roles: PropTypes.array,
    agencyGuid: PropTypes.array,
  }).isRequired,
  isLoading: PropTypes.bool,
  agencies: PropTypes.array.isRequired,
};

export default Agency;
